import {
  AcademicCapIcon, ArchiveBoxIcon, ArrowDownTrayIcon, ArrowPathIcon,
  BeakerIcon, BuildingOffice2Icon, BuildingOfficeIcon,
  Cog6ToothIcon, ComputerDesktopIcon, CubeIcon, CubeTransparentIcon,
  MapPinIcon, PresentationChartBarIcon, RectangleGroupIcon,
  ShieldExclamationIcon, ShoppingBagIcon, Squares2X2Icon,
  SquaresPlusIcon, TruckIcon, UserGroupIcon,
} from "@heroicons/react/24/outline";

// Use the stable server type, not the facility's user-entered name.
const icons: Record<string, typeof MapPinIcon> = {
  SITE: MapPinIcon,
  CAMPUS: AcademicCapIcon,
  BUILDING: BuildingOffice2Icon,
  FLOOR: Squares2X2Icon,
  CLASSROOM: PresentationChartBarIcon,
  LABORATORY: BeakerIcon,
  AUDITORIUM: UserGroupIcon,
  MEETING_ROOM: RectangleGroupIcon,
  OFFICE: BuildingOfficeIcon,
  RETAIL_STORE: ShoppingBagIcon,
  SALES_AREA: SquaresPlusIcon,
  STORAGE_AREA: CubeTransparentIcon,
  RECEIVING_AREA: ArrowDownTrayIcon,
  QUARANTINE_AREA: ShieldExclamationIcon,
  PACKING_AREA: CubeIcon,
  DISPATCH_AREA: TruckIcon,
  RETURNS_AREA: ArrowPathIcon,
  BIN: ArchiveBoxIcon,
  PRODUCTION_AREA: Cog6ToothIcon,
  WORKSTATION: ComputerDesktopIcon,
};

// Physical furniture and storage shapes absent from the shared icon set.
const shapes: Record<string, string> = {
  SEAT: "M7 13V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8M5 11v6h14v-6M5 14h14M7 17v4m10-4v4",
  SEATING_ROW: "M2 12V6h5v6m2 0V6h6v6m2 0V6h5v6M2 12h20v5H2zM4 17v3m8-3v3m8-3v3M8 12v5m8-5v5",
  WAREHOUSE: "M3 21V8l9-5 9 5v13M1 21h22M6 21V10h12v11M6 14h12M6 18h12",
  FACTORY_SITE: "M3 21V10l6 3V8l6 3V3h4l2 18H3Zm3-4h1m4 0h1m4 0h1",
  AISLE: "M3 3h5v18H3zM16 3h5v18h-5zM3 9h5m-5 6h5m8-6h5m-5 6h5M12 20V5m-2 2 2-2 2 2",
  RACK: "M4 3v18M20 3v18M4 9h16M4 16h16M7 4h4v5H7zM13 11h4v5h-4z",
  SHELF: "M3 5v15M21 5v15M3 12h18M6 6h5v6H6zM14 8h4v4h-4zM3 19h18",
  DISPLAY_SHELF: "M3 3v18M21 3v18M3 12h18M3 20h18M6 6h4v6H6zM14 4h4v8h-4zM8 16h8v4H8z",
  PRODUCTION_LINE: "M3 13h18a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2ZM5 13V6h6v7m3 0V4h5v9M5 16.5h.01M12 16.5h.01M19 16.5h.01",
};

export function FacilityTypeIcon({ typeCode }: { typeCode: string }) {
  const path = shapes[typeCode];
  if (path) return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={path} /></svg>;
  const Icon = icons[typeCode] ?? MapPinIcon;
  return <Icon aria-hidden="true" />;
}
